<template>
    <div style="display:grid; gap:15px">
        <h3>Periodos ocupados de operarios</h3>
        <div class="info-box">
            <div style="display:grid; grid-template-columns: 1fr 2fr; gap:50px; width: 100%;">
                <div style="display:flex;align-items:center; justify-content: center; gap:25px">
                    <label style="margin:0">Días mes</label>
                    <input type="checkbox" v-model="tipo_seleccionado" :true-value="'mes'">
                    <label style="margin:0">Días semana</label>
                    <input type="checkbox" v-model="tipo_seleccionado" :true-value="'semana'" >
                </div>
                <div style="display:grid; align-items: end;">
                    <label for="">Operario:</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text"><i class="fas fa-wrench"></i></span>
                        </div>
                        <select class="form-control" v-model="operario_seleccionado">
                            <option v-for="operario in operarios" :key="operario.id" :value="operario.id">{{ operario.nombre }}</option>
                        </select>
                        <div class="input-group-append">
                            <button class="btn btn-primary" @click="añadirOperario">Añadir</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div>     
            <div style="display:flex; justify-content: end;">
                <div style="display:flex; gap:5px; align-items:center; margin-bottom: 15px;">
                    <input type="text" class="form-control" v-model="buscador" aria-controls="tabla_guardias" placeholder="Buscador">
                    <button class="btn btn-primary" @click="obtenerListado(mievento)">Filtrar</button>
                </div>
            </div>
            <tabla-datos :botoncrear="1" @quieroDatos="obtenerListado($event); mievento = $event;" :total="total" :columnas="columnas" 
                :datos="listadoPeriodos" :filtros="false">
            </tabla-datos>
        </div>
    </div>
</template>
<script>
import TablaDatos from '../TablaDatos.vue';
import { PwgsApi } from '../../services/PwgsApi';
export default {
    props:[],
    components:{
        "tabla-datos": TablaDatos
    },
    data(){
        return{
            buscador:'',
            mievento:{},
            tipo_seleccionado:'semana',
            operario_seleccionado:'',
            operarios: [],
            listadoPeriodos: [],
            total:0,
            columnas: [
                {
                    header: 'Nombre',
                    field: 'nombre',
                },
                {
                    header: 'Mes',
                    field: 'mes_ocupados',
                },
                {
                    header: 'Días',
                    field: 'dias_guardias_ocupados',
                },
                {
                    header: 'Horas del día',
                    field: 'horas_dia_ocupados',
                },
                {
                    header: '',
                    field: 'eliminar_ocupado',
                }
            ]
        }
    },
    methods:{
        async añadirOperario(){
            const api = new PwgsApi();
            try{
                await api.post('crear-periodo-operario', {id_operario: this.operario_seleccionado, tipo: this.tipo_seleccionado});
                this.obtenerListado();
            }catch(e){
                this.$toast.add({severity:'error', summary: 'Error', detail: e, life: 5000});
            }
        },
        cargarDatos(){
            this.cargarOperarios();            
        },
        async obtenerListado(event){
            if(!this.operarios) return;
            if(!event) event = {};
            event.buscador = this.buscador;
            const api = new PwgsApi();
            const resp = await api.post('periodos-operarios', event);
            const periodos = Object.values(resp.datos || {});

            if (periodos.length > 0) {
                periodos.map(element => {
                    // El nombre se asigna sin esperar a la API
                    const operario = this.operarios.find(op => op.id == element.operarios_idoperario);
                    if (operario) element.nombre = operario.nombre;
                    var diasar = element.dias_mes.split(',');
                    var diasstring = '';
                    diasar.forEach(dia => {
                        if(dia!=''){
                            var dianuevo = dia.split('/')[0];
                            console.log('dia', dianuevo);
                            diasstring +=','+dianuevo;
                        }
                    })
                    element.dias_mes = diasstring;                    
                });
            }

            this.listadoPeriodos = periodos;
            this.total = resp.n_total_registros;
        },
        async cargarOperarios() {
            const api = new PwgsApi();
            const resp = await api.get('/operarios/simple');
            this.operarios = resp.datos;
            this.operario_seleccionado = this.operarios[0].id;
            this.obtenerListado();
        },
    },
    mounted(){
        this.cargarDatos();
    }
}

</script>
